import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, Box, Typography } from '@mui/material';
import { LAYOUT_CONSTANTS } from '../constants';
import PriceDisplay from './PriceDisplay';
import GetInTouchButton from './GetInTouchButton';

const TableHeaderCell = ({
  title,
  price,
  currency,
  currencies,
  theme = 'light',
  showCustom = false,
  hideUnit = false,
  sx = {},
}) => {
  const baseSx = {
    position: 'sticky',
    top: 0,
    zIndex: 11,
    fontWeight: 'bold',
    fontSize: { xs: '0.8rem', md: '1.1rem' },
    borderBottom: '2px solid #e2e8f0',
    textAlign: 'center',
    backgroundColor: 'inherit',
    px: { xs: 0, md: 2 },
    ...sx,
  };

  return (
    <TableCell sx={baseSx}>
      <Box
        sx={{
          minHeight: LAYOUT_CONSTANTS.TABLE_HEADER_MIN_HEIGHT,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: { xs: 'flex-start', md: 'center' },
          gap: 0.5,
          textAlign: 'center',
        }}
      >
        <div>{title}</div>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 1,
            mb: -0.5,
            visibility: price || !showCustom ? 'visible' : 'hidden',
          }}
        >
          Starting at
        </Typography>

        {price ? (
          <PriceDisplay
            price={price}
            currency={currency}
            currencies={currencies}
            showTotal={hideUnit}
            showUnit={!hideUnit}
            sx={{ mt: 1, fontSize: { xs: '0.9rem', md: '1.5rem' } }}
          />
        ) : showCustom ? (
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#0f172a', mt: 1 }}>
            Custom
          </Typography>
        ) : null}

        {GetInTouchButton(
          'small',
          {
            width: { xs: 'auto', md: 'auto' },
            minWidth: { xs: 132, md: 'auto' },
            whiteSpace: 'nowrap',
          },
          theme,
        )}
      </Box>
    </TableCell>
  );
};

TableHeaderCell.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number,
  currency: PropTypes.string.isRequired,
  currencies: PropTypes.object.isRequired,
  theme: PropTypes.string,
  showCustom: PropTypes.bool,
  hideUnit: PropTypes.bool,
  sx: PropTypes.object,
};

export default TableHeaderCell;
